import {
  userStatus,
  envConfig,
  EncryptMe
} from '../_helpers';

export const domainServices = {
  insertDomainService,
  removeRegisteredDomain,
  updateRegisteredDomain,
  verifyDomainByGero,
  getDomainsByCompanyUuid
}

async function insertDomainService(name, address) {
  const user = userStatus();

  let obj = {
    domain: {
      company_uuid: user.company_uuid,
      name: name,
      domain: address
    }
  }

  let encrypted = await EncryptMe(obj);

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'Access-Allow-Control-Origin': '*',
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/domain/create`, options);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function removeRegisteredDomain(uuid) {
  const user = userStatus();

  let obj = {
    domain: {
      uuid: uuid
    }
  }

  let encrypted = await EncryptMe(obj);

  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/domain/remove`, options);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function updateRegisteredDomain(name, address) {
  const user = userStatus();

  let obj = {
    domain: {
      name: name,
      address: address
    }
  }

  let encrypted = await EncryptMe(obj);

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/domain/update`, options);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function verifyDomainByGero(uuid){
  let user = userStatus();
  
  let encrypted = await EncryptMe({gero: {domain_uuid: uuid}});

  const options = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.bearer_token}`,
        'Access-Control-Allow-Origin': '*',
        'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/gero/validate`, options);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function getDomainsByCompanyUuid(){
  const user = userStatus();

  const options = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.bearer_token}`,
        'Access-Control-Allow-Origin': '*',
        'req-language': 'pt_BR'
    }
  }
 
  const response = await fetch(`${envConfig.MAIN_API_URL}/domain/list/${user.company_uuid}`, options);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}